//#region src/randomId.ts
function randomId(digits = 10) {
	return Math.floor(Math.random() * 10 ** digits).toString();
}

//#endregion
export { randomId };